function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Children } from 'react';
import { getKeys } from '@bydesign-ui/utils';
import { Emitter, getDefaultElementSize } from '@bydesign-ui/hooks';
export var Carousel = function (_Emitter) {
  _inherits(Carousel, _Emitter);

  var _super = _createSuper(Carousel);

  function Carousel(options) {
    var _this;

    _classCallCheck(this, Carousel);

    _this = _super.call(this);
    _this.currentIndex = 0;
    _this.preIndex = null;
    _this.sliders = [];
    _this.carouselSize = getDefaultElementSize();
    _this.timeId = null;
    var delay = options.delay,
        speed = options.speed,
        effect = options.effect,
        arrowSize = options.arrowSize,
        autoplay = options.autoplay,
        arrowTheme = options.arrowTheme,
        arrowFillColor = options.arrowFillColor,
        paginationColor = options.paginationColor,
        paginationActiveColor = options.paginationActiveColor,
        paginationType = options.paginationType,
        paginationPosition = options.paginationPosition;
    _this.delay = delay;
    _this.speed = speed;
    _this.effect = effect;
    _this.arrowSize = arrowSize;
    _this.autoplay = autoplay;
    _this.arrowSize = arrowSize;
    _this.arrowTheme = arrowTheme;
    _this.arrowFillColor = arrowFillColor;
    _this.paginationColor = paginationColor;
    _this.paginationActiveColor = paginationActiveColor;
    _this.paginationType = paginationType;
    _this.paginationPosition = paginationPosition;
    return _this;
  }

  _createClass(Carousel, [{
    key: "updateCarouselOptions",
    value: function updateCarouselOptions(options) {
      var _this2 = this;

      getKeys(options).forEach(function (key) {
        var value = options[key];

        if (value !== undefined) {
          if (key === 'autoplay' && _this2.autoplay !== options[key]) {
            if (options[key] === true) {
              _this2.restart();
            } else {
              _this2.stop();
            }
          }

          Object.assign(_this2, _defineProperty({}, key, value));
        }
      });
    }
  }, {
    key: "getRealCurrentIndex",
    value: function getRealCurrentIndex() {
      if (this.effect === 'slide') {
        var sliderCount = this.sliders.length;

        if (this.currentIndex > sliderCount - 3) {
          return 0;
        }

        if (this.currentIndex < 0) {
          return sliderCount - 3;
        }
      }

      return this.currentIndex;
    }
  }, {
    key: "slideTo",
    value: function slideTo(nextIndex, stopAnimate) {
      var _this3 = this;

      this.preIndex = this.currentIndex;
      this.currentIndex = nextIndex;

      switch (this.effect) {
        case 'slide':
          this.doSlideMode(stopAnimate);
          break;

        case 'fade':
        case 'cover-flow':
          this.doOtherMode();
          break;

        default:
          this.doOtherMode();
          break;
      }

      if (this.autoplay) {
        setTimeout(function () {
          _this3.startAutoplay();
        }, this.delay);
      }

      this.emit('active-index-change', this.getRealCurrentIndex());
    }
  }, {
    key: "startAutoplay",
    value: function startAutoplay() {
      var _this4 = this;

      this.clearTimer();
      this.timeId = setTimeout(function () {
        _this4.slideTo(_this4.currentIndex + 1);
      }, this.speed);
    }
  }, {
    key: "initCarouselSize",
    value: function initCarouselSize() {
      this.carouselSize.width = 0;
      this.carouselSize.height = 0;
    }
  }, {
    key: "initcurrentIndex",
    value: function initcurrentIndex() {
      this.currentIndex = 0;
    }
  }, {
    key: "setCarouselSize",
    value: function setCarouselSize(carouselSize) {
      this.carouselSize = carouselSize;
      this.slideTo(this.currentIndex, true);
      this.emit('carousel-size-change', carouselSize);
    }
  }, {
    key: "cloneChild",
    value: function cloneChild(originChild) {
      var originChildCount = Children.count(originChild);
      var arr = new Array(originChildCount + 2);

      if (originChildCount <= 1 || this.effect !== 'slide') {
        this.sliders = originChild;
        return;
      }

      Children.forEach(originChild, function (child, index) {
        if (index === 0) {
          arr[originChildCount + 1] = child;
        }

        if (index === originChildCount - 1) {
          arr[0] = child;
        }

        arr[index + 1] = child;
      });
      this.sliders = arr;
    }
  }, {
    key: "stop",
    value: function stop() {
      this.clearTimer();
    }
  }, {
    key: "restart",
    value: function restart() {
      this.startAutoplay();
    }
  }, {
    key: "clearTimer",
    value: function clearTimer() {
      if (this.timeId) {
        clearInterval(this.timeId);
        this.timeId = null;
      }
    }
  }, {
    key: "getTranslateStyle",
    value: function getTranslateStyle(stopAnimate) {
      var currentIndex = this.currentIndex,
          carouselSize = this.carouselSize,
          delay = this.delay,
          sliders = this.sliders;
      var time = stopAnimate ? 0 : delay;
      var translateSize = (sliders.length === 1 ? 0 : -1 - currentIndex) * carouselSize.width;
      return {
        transform: "translateX(".concat(translateSize, "px)"),
        transitionDuration: "".concat(time, "ms")
      };
    }
  }, {
    key: "doSlideMode",
    value: function doSlideMode(stopAnimate) {
      var _this5 = this;

      this.emit('begin-translate', this.getTranslateStyle(stopAnimate));

      if (this.currentIndex > this.sliders.length - 3 && this.sliders.length > 1) {
        this.currentIndex = 0;
        setTimeout(function () {
          _this5.slideTo(0, true);
        }, this.delay);
        return;
      }

      if (this.currentIndex < 0) {
        this.currentIndex = this.sliders.length - 3;
        setTimeout(function () {
          _this5.slideTo(_this5.sliders.length - 3, true);
        }, this.delay);
        return;
      }
    }
  }, {
    key: "doOtherMode",
    value: function doOtherMode() {
      if (this.currentIndex > this.sliders.length - 1) {
        this.currentIndex = 0;
      }

      if (this.currentIndex < 0) {
        this.currentIndex = this.sliders.length - 1;
      }

      this.emit('begin-translate', this.getTranslateStyle());
    }
  }]);

  return Carousel;
}(Emitter);